/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_About_Body2Inputs */

const ja_playdata_home_about_body2 = /** @type {(inputs: Playdata_Home_About_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さまざまな配信プラットフォームをカバーし、公式配信だけではなく人気ストリーマーのミラー配信データも計測し、多角的視点でのレポートを提供しています。`)
};

const en_playdata_home_about_body2 = /** @type {(inputs: Playdata_Home_About_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From official channels to mirror broadcasts and competitor analysis, we have you covered.`)
};

/**
* | output |
* | --- |
* | "From official channels to mirror broadcasts and competitor analysis, we have you covered." |
*
* @param {Playdata_Home_About_Body2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_about_body2 = /** @type {((inputs?: Playdata_Home_About_Body2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_About_Body2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_about_body2(inputs)
	return en_playdata_home_about_body2(inputs)
});